<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Vehicles</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Vehicles
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Vehicles</h4>
                </div>

                <div class="card-body">
<!--                    <form class="row g-3" @submit.prevent="searchTrips">-->
<!--                        <div class="form-group col-md-4">-->
<!--                            <input type="text" v-model="searchTrip.name" class="form-control"-->
<!--                                   placeholder="Name">-->
<!--                        </div>-->
<!--                        <div class="form-group col-md-4">-->
<!--                            <input type="text" v-model="searchTrip.email" class="form-control"-->
<!--                                   placeholder="Email">-->
<!--                        </div>-->
<!--                        <div class="form-group col-md-4">-->
<!--                            <input type="text" v-model="searchTrip.phone_number" class="form-control"-->
<!--                                   placeholder="Phone Number">-->
<!--                        </div>-->
<!--                        <div class="form-group col-md-4">-->
<!--                            <input type="text" v-model="searchTrip.company" class="form-control"-->
<!--                                   placeholder="Company Name">-->
<!--                        </div>-->
<!--                        <div class="form-group col-md-4 me-md-5">-->
<!--                            <date-picker v-model="searchTrip.dateJoined" type="date" placeholder="Date joined"-->
<!--                                         valueType="format" range></date-picker>-->
<!--                        </div> -->
<!--                        <div class="col-md-6">-->
<!--                            <button type="submit" class="btn btn-primary me-1">Search</button>-->
<!--                            <button type="button" @click="clearFilter" class="btn btn-primary me-1">Clear-->
<!--                                filter-->
<!--                            </button>-->
<!--                            <button type="button" @click="exportToCSV"-->
<!--                                    class="btn btn-secondary me-1">Export To CSV-->
<!--                            </button>-->
<!--                        </div>-->
<!--                    </form>-->

                    <div class="search-container pb-3">
                        <div class="row">
                            <div class="col-md-4 d-flex align-items-center">
                                <input id="search-term" type="text"
                                    class="table-search form-control form-control-sm"
                                    placeholder="🔍 Search this table"
                                    v-model="searchTerm"
                                    @keyup="paginatedData"
                                >
                            </div>

<!--                            <div class="col-lg-3 col-md-4 col-sm-6 d-flex">-->
<!--                                <download-excel type="csv" :data="admins" :export-fields="exportFields">-->
<!--                                    <a href="#" class="export-link"><i class="fas fa-file-csv"></i> export to csv</a>-->
<!--                                    | &nbsp;-->
<!--                                </download-excel>-->
<!--                                <download-excel :data="admins" :fields="exportFields">-->
<!--                                    <a href="#" class="export-link text-warning"><i class="fa fa-file-excel-o"></i>-->
<!--                                        export to excel-->
<!--                                    </a>-->
<!--                                </download-excel>-->
<!--                            </div>-->
                        </div>

                    </div>

                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allVehicles"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'owner_name'">
                                <a :href="props.row.ownership_type == 'fleet_managed' ? route('admin.fleet_managers.show', props.row.fleet_manager.id) :  route('admin.drivers.show', props.row.driver.id)">
                                    {{ props.row.ownership_type == 'fleet_managed' ? props.row.fleet_manager.full_name :  props.row.driver.full_name }}
                                </a>
                            </span>
                            <span v-else-if="props.column.field === 'driver_name'">
                                <a v-if="props.row.driver" :href="route('admin.drivers.show', props.row.driver.id)">
                                    {{ props.row.driver.full_name }}
                                </a>
                                <span v-else>Unassigned</span>
                            </span>
                            <span v-else-if="props.column.field === 'status'"
                                  :class="'badge-glow badge badge-' + statusClass(props.row.status)"
                            >
                                {{ props.row.status }}
                            </span>
                            <span v-else-if="props.column.field === 'action'">
                                <a :href="route('admin.vehicles.show', props.row.id)"><i class="feather icon-eye"></i> View</a>
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import th from "vue2-datepicker/locale/es/th";

export default {
    metaInfo: {title: 'Vehicles'},
    props: ['vehicles', 'type'],
    name: "VehicleIndex",
    layout: Layout,

    data: () => ({
        filter: {},
        isLoadingFilter: false,
        allVehicles: [],
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10
        },
        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },
        columns: [
            {label: 'S/N', field: 'sn'},
            {label: 'Owner Name', field: 'owner_name'},
            {label: 'Owner Type', field: 'ownership_type'},
            {label: 'Driver Name', field: 'driver_name'},
            {label: 'License Number', field: 'license_plate'},
            {label: 'Status', field: 'status'},
            {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
        searchTerm: '',
    }),
    created() {
        this.allVehicles = this.vehicles.data
        this.totalRecords = this.vehicles.total
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.paginatedData();
        },
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.paginatedData();
        },
        onSortChange(params) {
            this.serverParams.sort = {
                type: params[0].type,
                field: params[0].field,
            }
            this.paginatedData();
        },
        async paginatedData() {
            try {
                let url = route('admin.vehicles.index') +
                    `?type=${this.type}&q=${this.searchTerm}&page=${this.serverParams.page}&perPage=${this.serverParams.perPage}`;

                let {data: {data: {vehicles}}} = await axios.get(url);

                this.totalRecords = vehicles.total;
                this.paginationOptions.perPage = vehicles.per_page;
                this.allVehicles = vehicles.data
            } catch (e) {
                console.log(e);
            }
        },

        serialNo(props) {
            return this.serverParams.page === 1 ? props.index + 1 : (this.serverParams.perPage *
                    (this.serverParams.page - 1)) +
                props.index + 1
        },
        formatDateTime(value) {
            if (! value) return value

            const date = new Date(value);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        statusClass(value) {
            if (value === 'verification_failed' || value === 'suspended') {
                return "danger";
            }
            else if (value === 'verifying')
            {
                return "warning";
            } else if (value === 'active')
            {
                return "primary";
            }
            else
            {
                return "success";
            }
        },
        truncateWords(text, wordLimit = 3) {
            if (! text) return '';

            const words = text.trim().split(/\s+/);

            return words.length > wordLimit
                ? words.slice(0, wordLimit).join(' ') + '...'
                : text;
        },
        truncateText(text, length = 30) {
            return text?.length > length ? text.slice(0, length) + '...' : text;
        }
    }
}
</script>
